import { Component, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectorRef, Input } from '@angular/core';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { concat } from 'rxjs';

@Component({
  selector: 'app-customreportlinechart',
  templateUrl: './customreportlinechart.component.html',
  styleUrls: ['./customreportlinechart.component.scss']
})
export class CustomreportlinechartComponent implements OnInit {

  lineChart: Chart;
  lineChartTest: Chart;
  lineChartCount: any[] = [];
  @Input() chartdata: any;
  @Input() filterMethod: any;
  @Input() chartCount: any;
  icount: number = 0;

  @ViewChild("stackchartcanvas", { static: true }) stackchartcanvas: ElementRef<HTMLCanvasElement>;
  @Output() chartCreated = new EventEmitter<Chart>();

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    ///alert('line');
    //console.log('linegraphpg');
    //debugger;
    if (this.lineChart != null)
      this.lineChart.destroy();

    ///// https://stackoverflow.com/questions/24815851/how-to-clear-a-chart-from-a-canvas-so-that-hover-events-cannot-be-triggered
    //document.getElementById("DivLineCanvas").innerHTML = '&nbsp;';
    //document.getElementById("DivLineCanvas").innerHTML = '<div style="margin-left:270px"> </div>';
    //document.getElementById("DivLineCanvas").innerHTML = '<canvas ></canvas>';
    //debugger;
    this.BindLineChart();
    //this.BindTestLineChart();
    this.cdr.detectChanges();
  }

  //NOT IN USE
  ViewChildChart() {

    //// destroy line chart if already exist
   // if (this.lineChart != null)
     // this.lineChart.destroy();

    const canvas = this.stackchartcanvas.nativeElement;
    //canvas.id = idCount;
    const ctx = canvas.getContext("2d");

    this.lineChart = new Chart(ctx, {
      type: "line",
      data: {
        labels: ["Jan", "Feb", "March", "April", "May", "June", "July", "August"], ////label is no of groupname fetched from data result // rows.ChartData.Labels        
        datasets: [ ///dataset is no of column selected as bar from config screen
          {
            label: "ABC",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
            fill: false,
            //interval: 2,
            backgroundColor: this.RandomColorCode(),
            backgroundColorHover: this.RandomColorCode(),
            borderColor: this.RandomColorCode(),
            data: [1, 4, 2, 2, 5, 6, 7, 4, 3, 2, 1, 3, 4, 0, 7,],///data is selected column value //rows.ChartData.Dataset[0].Data
            lineTension: 0.1,
            borderWidth: 1,
            pointStyle: "line"
          }
        ]
      },
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        // Container for pan options
        pan: {
          // Boolean to enable panning
          enabled: true,

          // Panning directions. Remove the appropriate direction to disable 
          // Eg. 'y' would only allow panning in the y direction
          mode: 'xy'
        },

        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: false,

          // Zooming directions. Remove the appropriate direction to disable 
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'xy',
        },
        bezierCurve: false
      }
    });

    // Emit the chart instance to the parent
    //this.chartCreated.emit(this.lineChart);

  }

  GetDatasetData_Old(rows) {
    let data: any[] = [];
    for (let x = 0; x < rows.length; x++) {
      data.push(rows[x].Data[0]);
    }
    //console.log(data)
    return data;
  }
  GetDatasetData(Dataset, Labels, currGrp) {
    let data: any[] = [];
    for (let indx = 0; indx < Dataset.length - 1; indx++) {
      if (Dataset[indx].groupByCol === currGrp)
        data.push({ x: Labels[indx], y: Dataset[indx].Data[0] });
    }
    return data;
  }
  GetLineGraphDataset(rows) {
    let dataset: any[] = [];
    let color = this.RandomColorCode();

    //backgroundColor: this.RandomColorCode(),
    //backgroundColorHover: "#3e95cd",
    //borderColor: this.RandomColorCode(),

    //for (let k = 0; k < rows.length; k++) {
    //  color = this.RandomColorCode();
    //  dataset.push({
    //    label: rows[k].Dataset[0].Legend,//"Europe",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
    //    yAxisID: rows[k].Dataset[0].Legend,
    //    backgroundColor: color,//this.RandomColorCode(),
    //    borderColor: color,// this.RandomColorCode(),
    //    data: this.GetDatasetData(rows[k].Dataset), //rows.LineChartData.Dataset[i].Data,
    //    lineTension: 0.2,
    //    borderWidth: 1,
    //    pointStyle: "line",
    //    fill: false,
    //  });
    //}

    //debugger;
    if (this.filterMethod == "Aggregate") {
      for (let m = 0; m < rows.length; m++) {
        if (rows[m].Dataset.length > 0) {
          for (let k = 0; k < rows[m].GroupNames.split(',').length - 1; k++) {
            let currObj = rows[m].Dataset.filter(a => a.groupByCol == rows[m].GroupNames.split(',')[k]);
            //console.log(currObj)
            if (currObj.length > 0) {
              color = this.colorCodes[k];//this.RandomColorCode();
              dataset.push({
                label: currObj[0].groupByCol + ' (' + currObj[0].Legend+')', //rows[k].Dataset[0].Legend,//"Europe",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
                yAxisID: currObj[0].Legend, //rows[k].Dataset[0].Legend,
                backgroundColor: color,//this.RandomColorCode(),
                borderColor: color,// this.RandomColorCode(),
                data: this.GetDatasetData(rows[m].Dataset, rows[m].Labels, rows[m].GroupNames.split(',')[k]),//this.GetDatasetData(currObj), //rows.LineChartData.Dataset[i].Data,
                lineTension: 0.2,
                borderWidth: 1,
                pointStyle: "line",
                fill: false,
              });
            }
          }
        }
      }
    }
    else {
      for (let m = 0; m < rows.length; m++) {
        if (rows[m].Dataset.length > 0) {
          color = this.colorCodes[m];//this.RandomColorCode();
          dataset.push({
            label: rows[m].Dataset[0].Legend, //rows[k].Dataset[0].Legend,//"Europe",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
            yAxisID: rows[m].Dataset[0].Legend, //rows[k].Dataset[0].Legend,
            backgroundColor: color,//this.RandomColorCode(),
            borderColor: color,// this.RandomColorCode(),
            data: this.GetDatasetData_Old(rows[m].Dataset), //rows.LineChartData.Dataset[i].Data,
            lineTension: 0.2,
            borderWidth: 1,
            pointStyle: "line",
            fill: false,
          });
        }
      }
    }

    return dataset;
  }
  GetChartOptions(rows) {
    let options: any[] = [];

    for (let k = 0; k < rows.length; k++) {
      if (rows[k].Dataset.length > 0) {
        let position = 'left';
        if (k == 1)
          position = 'right';

        options.push({
          scaleLabel: {
            display: true,
            labelString: rows[k].Dataset[0].Legend
          },
          id: rows[k].Dataset[0].Legend,
          type: 'linear',
          position: position,
          ticks: {
            beginAtZero: true
          }
        });
      }
    }

    return options;
  }
  //https://stackoverflow.com/questions/67275805/grouping-y-axis-labels-on-multiple-lines-on-a-chartjs-with-an-extra-dimension
  BindLineChart() {
    //console.log('BindLineChart()-childcomp');
    if (this.lineChart != null)
      this.lineChart.destroy();

    let isLineGraphEmpty = true;
    let labelIndx = 0;
    debugger;
    for (let i = 0; i < this.chartdata.length; i++) {
      isLineGraphEmpty = true;
      if (this.chartdata[i].Labels.length > 0) {
        labelIndx = i;
        isLineGraphEmpty = false;
        break;
      }
    }

    //let labelsArray = [];
    //for (let i = 0; i < this.chartdata.length; i++) {
    //  labelsArray = [...labelsArray, ...this.chartdata[i].Labels];//labelsArray.concat(this.chartdata[i].Labels);
    //}
    //console.log(labelsArray)

    const canvas = this.stackchartcanvas.nativeElement;
    //canvas.id = idCount;

    const ctx = canvas.getContext("2d");
    //if (this.chartdata[0].Labels.length > 0) {
    if (isLineGraphEmpty==false) {
      this.lineChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.chartdata[labelIndx].Labels.map(x => new Date(x)),//rows.LineChartData.Labels, ////label is no of groupname fetched from data result // rows.ChartData.Labels
          datasets: this.GetLineGraphDataset(this.chartdata),
          //datasets: [ ///dataset is no of column selected as bar from config screen
          //  {
          //    label: rows.LineChartData.Dataset[0].Legend,/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
          //    fill: false,
          //    backgroundColor: this.RandomColorCode(),
          //    backgroundColorHover: "#3e95cd",
          //    data:this.GetLineGraphDataset(rows),  //[1, 4, 2, 2, 5, 6, 7, 4, 3, 2, 1, 3, 4, 0, 7,],///data is selected column value //rows.ChartData.Dataset[0].Data
          //    lineTension: 0.1,
          //    borderWidth: 1,
          //    pointStyle: "line"
          //  } 
          //]
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.GetChartTitle(this.chartdata) //this.chartdata[0].Dataset[0].Legend
          },
          scales: {
            xAxes: [{
              type: 'time',
              ////display: true,
              ////scaleLabel: {
              ////  display: true,
              ////  labelString: 'Date'
              ////},
              time: {
                min: new Date(this.chartdata[labelIndx].StartDate),
                max: new Date(this.chartdata[labelIndx].EndDate),
                ////parser: 'YYYY-MM-DD HH:mm:ss',
                unit: this.chartdata[labelIndx].dateUnit,//https://www.chartjs.org/docs/latest/axes/cartesian/time.html#time-units
                ////autoSkip: true,
                //tooltipFormat: "MM/DD/YYYY HH:mm:ss",//https://stackoverflow.com/questions/61474243/change-date-format-in-tooltip-of-chart-js
                displayFormats: {
                  second: "MM/DD/YYYY HH:mm:ss",
                  minute: "MM/DD/YYYY HH:mm",
                  hour: "MM/DD/YYYY HH:00",
                  day: "MM/DD/YYYY",
                  month: "MM/YYYY",
                  year: "YYYY"
                }
              },
              ticks: {
                ////major: {
                ////  fontStyle: 'bold',
                ////  fontColor: '#FF0000'
                ////}
                //autoSkip: false,
                maxRotation: 45,
                minRotation: 45
              }
            }],
            yAxes: this.GetChartOptions(this.chartdata),
            //yAxes: [
            //  {
            //    ticks: {
            //      beginAtZero: true
            //    }
            //  }
            //]
          },
          // Container for pan options
          pan: {
            // Boolean to enable panning
            enabled: false,

            // Panning directions. Remove the appropriate direction to disable 
            // Eg. 'y' would only allow panning in the y direction
            mode: 'xy'
          },

          // Container for zoom options
          zoom: {
            // Boolean to enable zooming
            enabled: false,

            // Zooming directions. Remove the appropriate direction to disable 
            // Eg. 'y' would only allow zooming in the y direction
            mode: 'xy',
          },
          bezierCurve: false
        }
      });
    }
    else {
      //////////////////// NO Data Found emty graph
      this.lineChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: [],// ["Red1", "blue", "orange", "green"], ////label is no of groupname fetched from data result // rows.ChartData.Labels
          //datasets: this.GetDataset(rows),
          datasets: [ ///dataset is no of column selected as bar from config screen
            {
              label: "No Data Found",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend                              
              data: [],///data is selected column value //rows.ChartData.Dataset[0].Data
            },
          ]
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.GetChartTitle(this.chartdata) //this.chartdata[0].Dataset[0].Legend
          },
          scales: {
            yAxes: [
              {
                position: 'left',
                ticks: {
                  precision: 0,
                  beginAtZero: true,
                  // display: false
                }
              }
            ],
          },
          // Container for pan options
          pan: {
            // Boolean to enable panning
            enabled: true,

            // Panning directions. Remove the appropriate direction to disable 
            // Eg. 'y' would only allow panning in the y direction
            mode: 'xy'
          },

          // Container for zoom options
          zoom: {
            // Boolean to enable zooming
            enabled: false,

            // Zooming directions. Remove the appropriate direction to disable 
            // Eg. 'y' would only allow zooming in the y direction
            mode: 'xy',
          },
          bezierCurve: false
        }
      });

    }
    ///} //end if

    this.lineChart.update();
    this.cdr.detectChanges();
    //// Emit the chart instance to the parent
    this.chartCreated.emit(this.lineChart);
  }

  GetChartTitle(rows) {
    let title = "";
    for (let k = 0; k < rows.length; k++) {
      //let position = '';
      //if (k == 1)
      //  position = ' AND ';
      //title = title + position + rows[k].Dataset[0].Legend;
      title = rows[k].LineGraphName;

    }
    return title;
  }

  //NOT IN USE
  BindTestLineChart() {
    const canvas = this.stackchartcanvas.nativeElement;
    //canvas.id = idCount;
    const ctx = canvas.getContext("2d");

    this.lineChart = new Chart(ctx, {
      type: "line",
      //plugins: [{
      //  afterLayout: chart => {
      //    var ctx = chart.chart.ctx;
      //    var xAxis = chart.scales['x-axis-0'];
      //    var gradientStroke = ctx.createLinearGradient(xAxis.left, 0, xAxis.right, 0);
      //    var dataset = chart.data.datasets[0];
      //    dataset.colors.forEach((c, i) => {
      //      var stop = 1 / (dataset.colors.length - 1) * i;
      //      gradientStroke.addColorStop(stop, dataset.colors[i]);
      //    });
      //    dataset.backgroundColor = gradientStroke;
      //    dataset.borderColor = gradientStroke;
      //    dataset.pointBorderColor = gradientStroke;
      //    dataset.pointBackgroundColor = gradientStroke;
      //    dataset.pointHoverBorderColor = gradientStroke;
      //    dataset.pointHoverBackgroundColor = gradientStroke;
      //  }
      //}],
      data: {
        labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],//this.chartdata[0].Labels,//rows.LineChartData.Labels, ////label is no of groupname fetched from data result // rows.ChartData.Labels
        //datasets: this.GetLineGraphDataset(this.chartdata),
        //datasets: [ ///dataset is no of column selected as bar from config screen
        //  {
        //    label: "ABC",///rows.LineChartData.Dataset[0].Legend,/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
        //    fill: false,
        //    backgroundColor: this.RandomColorCode(),
        //    backgroundColorHover: "#3e95cd",
        //    data:[1, 4, 2, 2, 5, 6, 7, 4, 3, 2, 1, 3, 4, 0, 7,],///data is selected column value //rows.ChartData.Dataset[0].Data
        //    lineTension: 0.1,
        //    borderWidth: 1,
        //    pointStyle: "line"
        //  } 
        //]
        //datasets: [{
        //  label: 'Cubic interpolation (monotone)',
        //  data: [0, 20, 20, 60, 60, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN],
        //  borderColor: "red",
        //  backgroundColor: 'rgba(0, 0, 0, 0)',
        //  fill: false,
        //  cubicInterpolationMode: 'monotone'
        //}, {
        //  label: 'Cubic interpolation (default)',
        //  data: [NaN, NaN, NaN, NaN, 60, 120, 140, 180, 120, NaN, NaN, NaN, NaN],
        //    borderColor: "blue",
        //  backgroundColor: 'rgba(0, 0, 0, 0)',
        //  fill: false,
        //}, {
        //  label: 'Linear interpolation',
        //  data: [NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, 120, 125, 105, 110, 170,200,300,400],
        //    borderColor: "yellow",
        //  backgroundColor: 'rgba(0, 0, 0, 0)',
        //  fill: false,
        //  lineTension: 0
        //}]

        datasets: [{
          label: 'Cubic interpolation (monotone)',
          data: [1, 2, 3, 4, 5, 6, 7, 1, 2, 3],
          fill: false,
          //colors: ['red', 'red', 'red', 'red', 'red', 'red', 'red', 'red', 'red', 'red'],
          borderColor: "yellow",
          lineTension: 0.1,
          borderWidth: 1,
          pointStyle: "line"
        },
        {
          label: 'Cubic ',
          data: [10, 20, 30, 40, 50, 60, 70, 40, 20, 30],
          fill: false,
          //colors: ['yellow'],
          borderColor: "blue",
          lineTension: 0.1,
          borderWidth: 1,
          pointStyle: "line"
        }
        ]
      },
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        // Container for pan options
        pan: {
          // Boolean to enable panning
          enabled: true,

          // Panning directions. Remove the appropriate direction to disable 
          // Eg. 'y' would only allow panning in the y direction
          mode: 'xy'
        },

        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: false,

          // Zooming directions. Remove the appropriate direction to disable 
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'xy',
        },
        bezierCurve: false
      }
    });
    // }

    this.lineChart.update();
    this.cdr.detectChanges();
  }

  RandomColorCode() {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return "#" + randomColor;
  }

  colorCodes: string[] = [
    //"#FF0000",
    //"#EE9ED9",
    //"#55FF55",
    //"#55AAFF",
    //"#C54F00",
    "#EE9ED9", "#FF0000", "#55FF55", "#55AAFF", "#C54F00", "#AA55FF", "#003B6D", "#FFA500"
  ];

}
